import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export const generatePDF = (data) => {
  const doc = new jsPDF({
    orientation: 'portrait',
  });

  doc.text("Reporte de calificaciones", 14, 10);
  doc.text("Lapso: " + data?.lapse?.name, 14, 20);

  let currentY = 35;

  // Iterar sobre las asignaturas en subjects
  Object.keys(data.subjects).forEach((subject) => {
    // Agregar el nombre de la materia al PDF
    doc.text(subject, 14, currentY);
    currentY += 10; // Ajustar el espacio después del título de la materia

    // Iterar sobre las secciones de la asignatura
    Object.keys(data.subjects[subject]).forEach((section) => {
      doc.text(`${section}`, 14, currentY);
      currentY += 5; // Espacio después del nombre de la sección

      // Preparar los datos de los estudiantes para esa sección
      const studentsData = data.subjects[subject][section].map((student) => [
        student.student_name,
        student.cedula,
        student.email,
        student.total_pond,
        //student.avg,
        student.evalutions_done,
      ]);

      // Definir los encabezados de la tabla
      const headers = [
        ['Nombre del estudiante', 'Cédula', 'Email', 'Total', 'Evaluaciones Realizadas']
      ];

      // Crear la tabla de estudiantes de cada asignatura y sección
      autoTable(doc, {
        head: headers,
        body: studentsData,
        startY: currentY,
        theme: 'grid',
        styles: { fontSize: 10 },
        headStyles: { fillColor: [200, 200, 200] },
      });

      currentY = doc.lastAutoTable.finalY + 10; // Actualizar la posición Y después de la tabla
    });
  });

  doc.save('Evaluaciones.pdf');
};
